// Handlebars helper to round distances to 2 decimals
module.exports = function (distance) {
    return parseFloat(distance).toFixed(2);
};